import React from "react";
import { Modal, Select } from "antd";
import { surveyTemplates } from "../../../utils/surveyTemplates/surveyTemplates";

const SelectSurveyTemplateModal = ({
    isOpen,
    onNext,
    onCancel,
    onSelectTemplate,
}) => {
    return (
        <Modal
            title="Select survey template"
            open={isOpen}
            onOk={onNext}
            onCancel={onCancel}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100px",
                }}
            >
                <Select
                    style={{ width: "100%" }}
                    allowClear
                    showSearch
                    placeholder="Select a template"
                    onChange={onSelectTemplate}
                    options={surveyTemplates.map((item) => ({
                        value: item.name,
                        label: item.name,
                    }))}
                />
            </div>
        </Modal>
    );
};

export default SelectSurveyTemplateModal;
